import { Box, Button, Grid, TextField, MenuItem } from "@mui/material";
import CollapseSection from "../../../components/ui/CollapseSection";
import Alert from "../../../components/ui/Alert";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { ExportBackendReport, setState } from "../analyzeSlice";

export default function BackendReport() {
  const dispatch = useDispatch();

  const [validate, setValidate] = useState({
    tableNameValidated: false,
    queryValidated: true,
  });

  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  const displayAlert = (showAlert, alertMessage) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: `${showAlert}`,
      alertMessage: `${alertMessage}`,
    });
  };

  useEffect(() => {
    //Check if any of the dropdown are false and then set alertDisplay to false
    const isAnyKeyValueFalse = (o) => !!Object.keys(o).find((k) => !o[k]);

    if (isAnyKeyValueFalse(validate)) {
      setAlert({ ...Alert, alertDisplay: false });
    }
  }, [validate]);

  const [selectedTableName, setSelectedTableName] = useState("");
  const [selectedQuery, setSelectedQuery] = useState("");

  const tableName = [
    {
      table: "VW_QuotaConditions",
      query:
        "select * from [VW_QuotaConditions] where Year(EffectiveStartDate)= XXX and Month(EffectivestartDate)= XXX",
    },
    {
      table: "Datasourcesrows",
      query:
        "select * from Datasourcesrows Where GEOID = XXX And year(period) > XXXX",
    },
    {
      table: "ScenarioSticktoQuota",
      query:
        "select s.*,u.FirstName, u.LastName from ScenarioSticktoQuota s inner join Users u on s.UpdatedBy = u.UserID",
    },
    {
      table: "ScenarioUnblockFullOrder",
      query:
        "select s.*,u.FirstName, u.LastName from ScenarioUnblockFullOrder s inner join Users u on s.UpdatedBy = u.UserID",
    },
    {
      table: "ScenarioModifyStickToQuota",
      query:
        "select s.*,u.FirstName, u.LastName from ScenarioModifyStickToQuota s inner join Users u on s.UpdatedBy = u.UserID",
    },
    {
      table: "scenarios",
      query: "select * from dbo.scenarios",
    },
    {
      table: "quotas",
      query: "select * from dbo.quotas ",
    },
    {
      table: "VW_Packs",
      query: "select * from dbo.VW_Packs",
    },
    {
      table: "VW_CustomerModifications",
      query: "select * from dbo.VW_CustomerModifications",
    },
    {
      table: "VW_Modifications",
      query:
        "select ModificationID, QuotaID, ModificationStatus, UpdateDate, UpdatedBy, ApprovedRejectedBy, MONTH(UpdateDate) as Month, YEAR (UpdateDate) as Year, DAY(UpdateDate) as Date from dbo.VW_Modifications",
    },
    {
      table: "VW_Scenarios",
      query:
        "select ScenarioID, EffectiveStartDate, YEAR(EffectiveStartDate) as Year, MONTH(EffectiveStartDate) as Month, DAY(EffectiveStartDate) as Date, Country, ScenarioName, PeriodType, ScenarioStatus, UpdatedBy, ApprovedRejectedBy from dbo.VW_Scenarios",
    },
    {
      table: "VW_Quotas",
      query:
        "select QuotaID, ScenarioID, ScenarioName, EffectiveStartDate, YEAR(EffectiveStartDate) as Year,MONTH(EffectiveStartDate) as Month, DAY(EffectiveStartDate) as Date, PeriodDepletionModel, QuotaStatus, UpdatedBy, ApprovedRejectedBy, CreatedBy from dbo.VW_Quotas",
    },
    {
      table: "VW_Customers",
      query: "select * from dbo.VW_Customers",
    },
    {
      table: "VW_ScenariosDetails",
      query: "select * from dbo.VW_ScenariosDetails",
    },
  ];

  const handleTableNameChange = (event) => {
    let value = event.target.value;

    if (value) {
      setValidate({
        ...validate,
        tableNameValidated: true,
      });
    }

    let query = tableName.filter((item) => item.table === value);

    setSelectedTableName(value);
    setSelectedQuery(query[0].query);
  };

  const handleQueryChange = (event) => {
    let query = event.target.value;

    if (query) {
      setValidate({
        ...validate,
        queryValidated: true,
      });
    } else {
      setValidate({
        ...validate,
        queryValidated: false,
      });
    }

    setSelectedQuery(query);
  };

  const handleExportData = () => {
    let query = selectedQuery;
    const obj = {
      tableName: selectedTableName,
      query: { query },
    };

    if (!validate.tableNameValidated)
      displayAlert(true, "Please select a table name");
    else if (!validate.queryValidated)
      displayAlert(true, "No query available for selected table");
    else {
      dispatch(ExportBackendReport(obj));
    }
  };

  return (
    <div>
      <CollapseSection title="Backend Reports">
        <Box mt={4}>
          <Box mt={2}>
            {alert.alertDisplay && (
              <Alert
                message={alert.alertMessage}
                severity={alert.alertSeverity}
              />
            )}
            <Grid
              container
              columns={12}
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              pb={1}
            >
              <Grid item xs={6} sm={3} md={3} lg={3}>
                <label>Select Table:</label>
                <TextField
                  sx={{ mt: 1 }}
                  variant="outlined"
                  label=""
                  select={tableName.length > 0 ? true : false}
                  value={tableName.length > 0 ? selectedTableName.table : ""}
                  onChange={handleTableNameChange}
                  size="small"
                >
                  {tableName.length > 0
                    ? tableName.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item.table}>
                            {item.table}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </Grid>
              <Grid item xs={6} sm={5} md={10} lg={10.6}>
                {/* <label>
              Query:
              <textarea name="postContent" rows={4} cols={40} />
            </label> */}
                <label>Query:</label>
                <TextField
                  sx={{ mt: 1 }}
                  className="twoLines"
                  value={selectedQuery}
                  overflow="scroll"
                  multiline
                  id="outlined-basic"
                  label=""
                  rows={2}
                  variant="outlined"
                  onChange={handleQueryChange}
                />
              </Grid>
              <Grid item xs={6} sm={4} md={2} lg={1.2} mt={4}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleExportData}
                >
                  Export
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </CollapseSection>
    </div>
  );
}
